import { useInfiniteQuery } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getAppInstallationsKey } from '../../utils/keys';
export const useAppInstallations = (options) => {
    const { variables, fields = 'basic', useInfiniteQueryOptions } = options || {};
    const { client } = useTribeClient();
    const appInstallationsKey = getAppInstallationsKey(variables);
    return useInfiniteQuery(appInstallationsKey, ({ pageParam: after }) => client === null || client === void 0 ? void 0 : client.app.appInstallations({ after, ...variables }, fields), useInfiniteQueryOptions);
};
//# sourceMappingURL=useAppInstallations.js.map